// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';
import { CreditMethod } from '../../types/Model';

export interface BuyChallengeRequestPayload {
  id: number;
  test?: boolean;
  workshopId?: number;
  courseId?: number;
  iltCourseId?: number;
  creditMethod?: CreditMethod;
  success?: () => void;
  onError?: (error:string) => void;
}
export interface BuyChallengeSuccessPayload {}

export interface BuyChallengeFailPayload {
  error: Error;
}

export const buyChallengeActions = createAsyncAction(
  'elearning/BUY_CHALLENGE',
  'elearning/BUY_CHALLENGE_SUCCESS',
  'elearning/BUY_CHALLENGE_FAIL'
)<
  BuyChallengeRequestPayload,
  BuyChallengeSuccessPayload,
  BuyChallengeFailPayload
>();
